
import React from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import EditAccountForm from '../../common/client/components/EditAccountForm';
import IfComp from '../../common/client/components/IfComp';
import Text from '../../common/client/components/Text';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';
import useAuthIsLogged from '../../common/client/hooks/mysliveckyportal/useAuthIsLogged';
import useAuthIsAccountActivated from '../../common/client/hooks/mysliveckyportal/useAuthIsAccountActivated';

import useNavigationItems  from '../../hooks/useNavigationItems';

const classNames = mergeStyleSets({
    EditAccountPage: {
    },
    panel: {
        backgroundColor: '#ffffff',
        marginTop: 64,
        marginBottom: 64,
        padding: 8,
        border: '1px solid #999999',
        width: 430
    },
});


const Content = ({logged}) => {
    const history = useHistory();
    const isActivated = useAuthIsAccountActivated();

    const handleCancelClick = () => {
        history.push('/');
    }

    if (!isActivated) {
        return <Redirect to="/" />;
    }

    return (
        <IfComp cond={logged}>
            <EditAccountForm
                onCancelClick={handleCancelClick}
            />
        </IfComp>
    );
}

const EditAccountPage = () => {

    const logged = useAuthIsLogged();
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            navigationItems={navigationItems}
        >
            <Stack className={classNames.EditAccountPage}>
                <Stack.Item className={classNames.panel} align="center">
                    <Text xxLarge>Aktualizace uživatelského účtu</Text>
                    <Content
                        logged={logged}
                    />
                </Stack.Item>
            </Stack>
        </AppPageStyle>
    );
}

export default EditAccountPage;
